module.exports = __webpack_public_path__ + "img/AutomatedFollowupsActive.61bb4c41.svg";